import React from "react";

const AboutRust = () => (
  <div className="main-rust-container">
    <div className="rust-container">
      <div className="rust-signup-container">
        <div className="rust-header">
        </div>
        <div className="rust-description">
          <h3>What’s Next?</h3>
          <p>
            You now have access to Neil Young’s complete musical legacy, exclusive films, unreleased tracks, and more.
          </p>
          <ul className="rust-features">
            <li>Browse the archives and discover rare recordings.</li>
            <li>Watch exclusive concert films and documentaries.</li>
            <li>Read stories and news directly from Neil Young and the NYA team.</li>
            <li>Enjoy your free month—no credit card required, no automatic renewal.</li>
          </ul>
          <p>
            Explore, listen, and enjoy! If you have any questions, email us at <a href="mailto:RUST@NEILYOUNGARCHIVE.COM">RUST@NEILYOUNGARCHIVE.COM</a>.
          </p>
        </div>
        <div className="welcome-buttons">
          <a className="welcome-button" href="/">
            Go to Welcome Page
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default AboutRust;